(() => {
 const root=document.querySelector('product-info'); if(!root)return;
 const label=()=>{
 const original=root.querySelector('#gs-builder-btn');
 if(original && !original.dataset.zpAccessible){
  original.dataset.zpAccessible='true';
  const button=document.createElement('button');
  button.type='button';button.className='button button--full-width zp-upload-button';
  button.textContent=original.textContent.trim();
  button.addEventListener('click',()=>original.click());
  original.before(button);
  original.setAttribute('aria-hidden','true');original.setAttribute('tabindex','-1');
  original.classList.add('zp-app-trigger');
 }
 root.querySelectorAll('.gpo-app input[type="radio"]').forEach(input=>{
  if(!input.hasAttribute('aria-label'))input.setAttribute('aria-label',input.value);
  input.closest('.gpo-swatches')?.querySelectorAll('img:not([alt])').forEach(img=>img.alt=input.value);
 });
 };
 label();const observer=new MutationObserver(label);observer.observe(root,{childList:true,subtree:true});
})();
